import { createContext, useContext, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import CTABand from './CTABand';
import Footer from './Footer';
import CartDrawer from './CartDrawer';

type CartUI = { openCart: () => void; closeCart: () => void };
const CartUIContext = createContext<CartUI>({ openCart: () => {}, closeCart: () => {} });

/** Lets any page open the cart drawer (e.g. right after an add-to-cart). */
export function useCartUI() {
  return useContext(CartUIContext);
}

export default function Layout() {
  const [cartOpen, setCartOpen] = useState(false);
  const { pathname } = useLocation();

  // Router navigation keeps the old scroll offset otherwise.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <CartUIContext.Provider
      value={{ openCart: () => setCartOpen(true), closeCart: () => setCartOpen(false) }}
    >
      <div className="min-h-screen flex flex-col bg-surface">
        <Header onCartClick={() => setCartOpen(true)} />
        <main className="flex-1 pt-[72px] md:pt-20">
          <Outlet />
        </main>
        <CTABand />
        <Footer />
        <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
      </div>
    </CartUIContext.Provider>
  );
}
